import theme from "../../../../js/shared/new-theme";

export const defaultStyle = (overflow) => `
	display: flex;
	flex-direction: column;
	position: relative;
	width: 100%;
	height: 100%;
	border-radius: 4px;
	overflow: ${overflow ? "hidden" : "unset"};
	box-shadow: ${theme.shadows[200]};
`;

export const headerStyle = `
	display: flex;
	background: ${theme.palette.common.white};
	padding: 24px 16px;
	border-bottom: solid 1px ${theme.palette.gray[400].value};
`;

export const contentStyle = `
	display: flex;
	background: ${theme.palette.common.white};
`;

export const footerStyle = `
	display: flex;
	justify-content: space-between;
	background: ${theme.palette.common.white};
	padding: 24px 36px;
	border-top: solid 1px ${theme.palette.gray[400].value};
`
